import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useQuery as useProtectedBrandsQuery } from "@faire/web-api--source/api/retailer/retailerToken/zip-code-protected-brands/get-hooks";
import { trackZipCodeProtectionBrandBlocked } from "@faire/web-api--source/events/zipCodeProtection/actionUnknown/brandBlocked";
import { useCallback, useMemo } from "react";
import { useIsValidRetailer } from "./useIsValidRetailer";
/**
 * Faire protection can be enabled per brand/maker and is awarded to one
 * retailer per zipcode / postal code for a 90 day period.
 *
 * This hook allows one to query whether or not the current logged in
 * retailer is able to place an order from a particular maker/brand
 *
 * NOTE: this logic does NOT take into account other reasons a retailer
 * may not be able to order from a maker (like residing in a forbidden state
 * for that maker)
 */ export var useFaireProtection = function() {
    var isValidRetailer = useIsValidRetailer().isValidRetailer;
    var retailerToken = useRetailer().retailerToken;
    var _useProtectedBrandsQuery = useProtectedBrandsQuery(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", {
        enabled: isValidRetailer,
        staleTime: 1000 * 60 * 3,
        refetchOnMount: false
    }), data = _useProtectedBrandsQuery.data, isLoading = _useProtectedBrandsQuery.isFetching, refetch = _useProtectedBrandsQuery.refetch;
    var forbiddenBrandTokens = useMemo(function() {
        var _data_brand_tokens;
        return (_data_brand_tokens = data === null || data === void 0 ? void 0 : data.brand_tokens) !== null && _data_brand_tokens !== void 0 ? _data_brand_tokens : [];
    }, [
        data === null || data === void 0 ? void 0 : data.brand_tokens
    ]);
    var isBrandTokenForbidden = useCallback(function(brandToken, options) {
        var _data_brand_tokens;
        var _data_brand_tokens_includes;
        var isBlocked = (_data_brand_tokens_includes = data === null || data === void 0 ? void 0 : (_data_brand_tokens = data.brand_tokens) === null || _data_brand_tokens === void 0 ? void 0 : _data_brand_tokens.includes(brandToken)) !== null && _data_brand_tokens_includes !== void 0 ? _data_brand_tokens_includes : false;
        if (isBlocked && (options === null || options === void 0 ? void 0 : options.trackReason)) {
            var _data_blocked_reasons_brandToken;
            var _data_blocked_reasons_brandToken_reason_codes;
            var blockedReasons = (_data_blocked_reasons_brandToken_reason_codes = data === null || data === void 0 ? void 0 : (_data_blocked_reasons_brandToken = data.blocked_reasons[brandToken]) === null || _data_blocked_reasons_brandToken === void 0 ? void 0 : _data_blocked_reasons_brandToken.reason_codes) !== null && _data_blocked_reasons_brandToken_reason_codes !== void 0 ? _data_blocked_reasons_brandToken_reason_codes : [];
            blockedReasons.forEach(function(reason) {
                return trackZipCodeProtectionBrandBlocked(brandToken, reason.toString());
            });
        }
        return isBlocked;
    }, [
        data
    ]);
    var expirationTime = useCallback(function(brandToken) {
        var _data_protected_for_retailer;
        return data === null || data === void 0 ? void 0 : (_data_protected_for_retailer = data.protected_for_retailer) === null || _data_protected_for_retailer === void 0 ? void 0 : _data_protected_for_retailer[brandToken];
    }, [
        data === null || data === void 0 ? void 0 : data.protected_for_retailer
    ]);
    return {
        isLoading: isLoading,
        forbiddenBrandTokens: forbiddenBrandTokens,
        zipCode: data === null || data === void 0 ? void 0 : data.zip_code,
        expirationTime: expirationTime,
        isBrandTokenForbidden: isBrandTokenForbidden,
        refetchFaireProtection: refetch
    };
};
